<template>

    <div>
        <div class="mb5"></div>
        <form class="form-horizontal" @onsubmit.prevent action>
            <div class="cat-form">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group" :class="{ 'has-error': validation.hasError('fname') }">
                            <label class="form-control-label">Name</label>
                            <input type="text" class="form-control inmarginbtm" placeholder="Name" value
                                v-model="fname" />
                            <div class="error">{{ validation.firstError('fname') }}</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group" :class="{ 'has-error': validation.hasError('category') }">
                            <label for="select-category" class="form-control-label">Category</label>
                            <select id="select-category" class="form-control" v-model="category"
                                @change="changeCategory">
                                <option value="Select Category" id="0">Select Category</option>
                                <option v-for="(f, index) in categoryList" :value="f.value" :label="f.value"
                                    :key="index + f.value">{{
                                        f.value
                                    }}</option>
                            </select>
                            <div class="error">{{ validation.firstError('category') }}</div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group" :class="{ 'has-error': validation.hasError('image') }">
                            <label class="form-control-label">Photo</label>
                            <!-- <input type="image" class="form-control" placeholder="image" v-model="image" /> -->
                            <ImageUpload @imageFileSelect="imageFileSelect" :selectedFile="selectedFile" />
                            <div class="error">{{ validation.firstError('image') }}</div>
                        </div>
                    </div>
                </div>
                <div class="raw">
                    <div class="col-md-12" v-if="errors && errors.length > 0">{{ errors }}</div>
                </div>
                <div class="w-full d-flex justify-content-center">
                    <button type="button" @click="submitHandler" class="btn btn-info">
                        {{ selectedCategoryObj.hasOwnProperty('_id') ? 'Update' : 'Submit' }}
                    </button>

                </div>
            </div>
        </form>
    </div>
</template>

<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import ImageUpload from "./ImageUpload.vue";
import SimpleVueValidation from "simple-vue-validator";
var Validator = SimpleVueValidation.Validator;
export default {
    name: "UpdateForm",
    props: ["getUrl", "createUpdateUrl", "deleteUrl", "getCategoryURL", "tabOneTitle", "selectedCategoryObj"],
    components: { ImageUpload },
    data() {
        return {
            errors: [],
            previewUrl: null,
            category: "Select Category",
            selCategory: {},
            fname: "",
            image: [],
            selectedFile: "",
            _tabOneTitle: this.tabOneTitle,
            _getUrl: this.getUrl,
            _createUpdateUrl: this.createUpdateUrl,
            _deleteUrl: this.deleteUrl,
            _getCategoryURL: this.getCategoryURL,
            _selectedCategoryObj: this.selectedCategoryObj,
            categoryList: [],
        };
    },
    watch: {
        getUrl(value) {
            //console.log("getUrl:::", value);
            this._getUrl = String(value);
        },
        createUpdateUrl(value) {
            //console.log("createUpdateUrl:::", value);
            this._createUpdateUrl = String(value);
        },
        deleteUrl(value) {
            //console.log("deleteUrl:::", value);
            this._deleteUrl = String(value);
        },
        getCategoryURL(value) {
            //console.log("curTab:::", value);
            this._getCategoryURL = String(value);
        },
        tabOneTitle(value) {
            this._tabOneTitle = String(value);
        },
        selectedCategoryObj: {
            handler(newValue, oldValue) {
                //console.log('#### >>>>', newValue, oldValue);
                console.log('#### >>>>', newValue);
                this._selectedCategoryObj = newValue;
                if (newValue.hasOwnProperty('_id')) {

                    let categoryFilterData = this.categoryList.filter((item) => {
                        return item._id === newValue.category_id;
                    });
                    if (categoryFilterData.length > 0) {
                        this.category = categoryFilterData[0].value;
                        this.selCategory = categoryFilterData[0];
                    }
                    this.fname = newValue.name;
                    this.selectedFile = newValue.image_url;
                    //[{ name: newValue.image_url, size: 140777, type: "image/jpeg" }];
                    console.log('##### %%%%% ##### ', newValue);
                } else {
                    this.selectedFile = "";
                    this.fileInputValue = "";
                    this.thumbnailUrl = "";
                    this.fname = "";
                    this.category = "Select Category";
                    //this.validator.reset();
                }
                //this.category = newValue.hasOwnProperty('_id') ? newValue


            },
            deep: true
        },
        /* selectedCategoryObj(value) {
            console.log('### this.selectedCategoryObj ### ', this.selectedCategoryObj);
            this._selectedCategoryObj = value;
        }, */
    },
    created() {
        console.log('_getCategoryURL', this.getCategoryURL);
        this._getCategoryURL = String(this.getCategoryURL);
        this._tabOneTitle = String(this.tabOneTitle);
        this._selectedCategoryObj = this.selectedCategoryObj;
        console.log('>>>>', this._selectedCategoryObj);
        this.getCategoryData();
        //this.validator.reset();

    },
    validators: {
        fname: function (value) {
            console.log('category name', value)
            return Validator.value(value).required();
        },
        category: function (value) {
            console.log('category value', value)
            return Validator.value(value)
                .required()
        },
        image: function (value) {
            console.log('image file validate', value)
            return Validator.value(value)
                .required()
        },
    },
    methods: {
        changeCategory(event) {

            this.selCategory = this.categoryList[event.target.selectedIndex - 1];
            //event.target.selectedIndex, self.categoryList[event.target.selectedIndex - 1]
            console.log(this.categoryList[event.target.selectedIndex - 1]);
        },
        imageFileSelect(file) {
            console.log('image file:::', file);
            this.image = file;
        },
        getCategoryData() {
            let self = this;
            console.log('self.cGetUrl >>>>', self._getCategoryURL);
            if (self._getCategoryURL.length > 0) {
                http.get(self._getCategoryURL, {}, (error, response) => {
                    console.log('getCategoryMasterData:', response);
                    if (response.status === 'success') {
                        const categoryData = response.data;
                        let categoryFilterData = categoryData.map((item) => {
                            return { _id: item._id, value: item.category_name };
                        });
                        //console.log('>>> categoryList >>> ', categoryFilterData);
                        self.categoryList = categoryFilterData;
                    }
                });
            }
        },
        submitHandler() {
            let self = this;
            this.$validate(["fname", "category", "image"]).then(success => {
                console.log('on success ' + success)
                if (success) {

                    console.log('self.category >>>', self.category);
                    console.log('self.selCategory >>>', self.selCategory);

                    if (self.selCategory._id == undefined) {
                        self.$toastr.error("Please select category", "", {});
                        return;
                    }


                    let dataForm = new FormData();
                    dataForm.append("name", self.fname);
                    dataForm.append("category_id", self.selCategory._id);
                    dataForm.append("image", self.image);
                    //console.log('dataForm::: ', dataForm.get("image"));
                    console.log('_createUpdateUrl::: ', self.createUpdateUrl);
                    console.log('Submit fname::: ', self.fname);
                    console.log('Submit category::: ', self.category);
                    console.log('Submit image::: ', self.image);


                    //return;
                    http.post(self.createUpdateUrl, dataForm, function (
                        error,
                        response
                    ) {
                        if (!error) {
                            console.log("response", response);
                            if (response.responseType === "success") {
                                self.$toastr.success(response.msg, "", {});
                                //_this.clearForm();
                            } else {
                                self.$toastr.error(response.msg, "", {});
                                self.errors = response.msg;
                            }
                        } else {
                            console.log("error", error);
                        }
                    });
                } else {
                    console.log('not-success', success)
                }
            })
        }
    }

}
</script>
<style scoped>
.cat-form {
    border: 1px solid #e9e9e9;
    border-radius: 7px;
    padding: 17px;
}
</style>


// WEBPACK FOOTER //
// src/views/partners/UpdateForm.vue